import React from "react";
import { useNavigate } from "react-router-dom";
const UserRollCom = (props) => {
  const navigate = useNavigate();
  return (
    <div
      className={`${props.themeclass} relative`}
      style={{ backgroundColor: props.bgColor }}
      onClick={() => navigate(props.to)}
    >
      {props.comingSoon && (
        <div
          className={`absolute font-onestMedium xs:text-sm sm:text-sm lg:text-base xs:px-2.5 xs:py-1 sm:px-2.5 sm:py-1 lg:px-3.5 lg:py-1.5 xs:rounded-[4px] sm:rounded-md top-0 right-0 shadow-[0px_6px_6px_rgba(0,0,0,0.2)] bg-accepted`}
        >
          {props.comingSoon}
        </div>
      )}
      <img src={props.icon} className={props.iconsClass} alt="user roll icon" />
      <div className="xs:pt-1 lg:pt-2">
        <h3 className={`${props.textclass}`}>{props.title}</h3>
      </div>
    </div>
  );
};
export default UserRollCom;
